import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { catchError, mergeMap } from 'rxjs/operators';
import { AddBijbEventAction } from '../../actions/bijb-event/add-event-action';
import { AddBijbEventErrorAction } from '../../actions/bijb-event/add-event-error-action';
import { GetBijbEventsAction } from '../../actions/bijb-event/get-events-action';
import { RememberEventService } from '../../../services/remember-event/remember-event.service';
import { GetCurrentAccountAction } from '../../actions/current-account/get-current-account-action';
import { from, of } from 'rxjs';
import { GetBijbEventSuccessAction } from '../../actions/bijb-event/get-event-success-action';

@Injectable()
export class AddBijbEventEffect {
  constructor(private api: ApiService,
    private actions: Actions,
    private rememberEventService: RememberEventService) {
  }


  public AddBijbEvent = createEffect(() => this.actions
    .pipe(
      ofType(AddBijbEventAction.type),
      mergeMap(action => {
        const addBijbEventAction = <AddBijbEventAction>action;
        return from(this.api.addEvent(addBijbEventAction.name, addBijbEventAction.affiliate))
          .pipe(
            mergeMap(event => {
              this.rememberEventService.setLastEvent(event.id);
              return of(new GetBijbEventsAction(), new GetBijbEventSuccessAction(event), new GetCurrentAccountAction());
            }),
            catchError(e => {
              return of(new AddBijbEventErrorAction(e));
            })
          );
      })
    ));
}
